import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify";

function SetFakeSystem() {
  const { apiBaseUrl } = useAuth();
  const [formData, setFormData] = useState({
    target: "groups",
    fake_system_start_time: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [updatedData, setUpdatedData] = useState(null); // 👈 برای نمایش داده‌های بعد از update

  // 👇 تابع برای دریافت broker time از GetFakeSystem
  const fetchBrokerTime = async (target) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/get/fake-system`,
        { target },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      console.log(response);

      const brokerTimeFromAPI = response.data?.data?.data?.current_broker_time;
      
      if (brokerTimeFromAPI) {
        // تبدیل broker time به فرمت datetime-local (YYYY-MM-DDTHH:MM)
        const formattedTime = brokerTimeFromAPI.replace(" ", "T").substring(0, 16);
        
        setFormData(prev => ({
          ...prev,
          fake_system_start_time: formattedTime
        }));
      }

      return response.data?.data?.data; // 👈 برگردوندن کل data
    } catch (error) {
      console.error("Error fetching broker time:", error);
      toast.error("خطا در دریافت زمان broker");
    }
  };

  // 👇 useEffect برای call کردن get fake system موقع mount
  useEffect(() => {
    fetchBrokerTime(formData.target);
  }, [formData.target]); // وقتی target عوض میشه هم دوباره call میشه

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setUpdatedData(null); // 👈 پاک کردن داده‌های قبلی

    try {
      const formattedTime = formData.fake_system_start_time + ":00";

      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/set/fake-system`,
        {
          target: formData.target,
          fake_system_start_time: formattedTime,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.data.success || response.data.ok) {
        const successMessage = "Fake System با موفقیت تنظیم شد";
        setMessage(successMessage);
        toast.success(successMessage);
        
        // 👇 بعد از موفقیت، دوباره get fake system رو call کن
        const newData = await fetchBrokerTime(formData.target);
        if (newData) {
          setUpdatedData(newData); // 👈 ذخیره داده‌های جدید
          toast.info("اطلاعات به‌روز شد");
        }
      }
    } catch (error) {
      console.error("❌ خطا در تنظیم Fake System:", error);
      const errorMessage = error.response?.data?.message || "خطا در تنظیم Fake System";
      setMessage(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const addHour = () => {
    if (!formData.fake_system_start_time) return;

    try {
      const date = new Date(formData.fake_system_start_time);
      date.setHours(date.getHours() + 1);
      const formatted =
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0") +
        "T" +
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0");
      setFormData({ ...formData, fake_system_start_time: formatted });
    } catch (error) {
      console.error("Error adding hour:", error);
    }
  };

  const subtractHour = () => {
    if (!formData.fake_system_start_time) return;

    try {
      const date = new Date(formData.fake_system_start_time);
      date.setHours(date.getHours() - 1);
      const formatted =
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0") +
        "T" +
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0");
      setFormData({ ...formData, fake_system_start_time: formatted });
    } catch (error) {
      console.error("Error subtracting hour:", error);
    }
  };

  return (
    <div className="space-y-6 p-6">
      <div className="bg-indigo-900/20 border border-indigo-600 rounded-lg p-4 mb-6">
        <h3 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
          <span>🎭</span> تنظیم Fake System Start Time
        </h3>
        <p className="text-indigo-300 text-sm">تعیین زمان شروع سیستم Fake</p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Target Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            انتخاب نوع حساب (Target):
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="individuals"
                checked={formData.target === "individuals"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Individuals (حساب‌های فردی)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="groups"
                checked={formData.target === "groups"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Groups (گروه‌ها)</span>
            </label>
          </div>
        </div>

        {/* Fake System Start Time */}
        <div>
          <label className="block text-white font-medium mb-2">
            fake_system_start_time <span className="text-red-400">*</span>
          </label>
          <p className="text-gray-400 text-sm mb-3">
            انتخاب تاریخ و ساعت (مقدار پیش‌فرض از Broker Time)
          </p>

          <div className="flex gap-2">
            {/* دکمه -1 ساعت */}
            <button
              type="button"
              onClick={subtractHour}
              disabled={!formData.fake_system_start_time}
              className="px-4 py-3 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white font-bold rounded-lg transition duration-200"
              title="کم کردن 1 ساعت"
            >
              -1h
            </button>

            {/* Input datetime-local */}
            <input
              type="datetime-local"
              value={formData.fake_system_start_time}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  fake_system_start_time: e.target.value,
                })
              }
              className="flex-1 p-3 bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-indigo-500 focus:outline-none"
              required
            />

            {/* دکمه +1 ساعت */}
            <button
              type="button"
              onClick={addHour}
              disabled={!formData.fake_system_start_time}
              className="px-4 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-bold rounded-lg transition duration-200"
              title="اضافه کردن 1 ساعت"
            >
              +1h
            </button>
          </div>

          {/* نمایش Preview */}
          {formData.fake_system_start_time && (
            <div className="mt-3 bg-gray-700/50 rounded p-3">
              <p className="text-gray-400 text-xs mb-1">فرمت ارسالی به API:</p>
              <p className="text-white font-mono text-sm">
                {formData.fake_system_start_time}:00
              </p>
            </div>
          )}
        </div>

        {/* Warning */}
        <div className="bg-yellow-900/20 border border-yellow-600 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <span className="text-yellow-400 text-2xl">⚠️</span>
            <div>
              <h4 className="text-yellow-400 font-medium mb-1">توجه</h4>
              <p className="text-gray-300 text-sm">
                با تنظیم Fake System Start Time، سیستم از زمان مشخص شده به جای
                زمان واقعی استفاده خواهد کرد
              </p>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading || !formData.fake_system_start_time.trim()}
          className="w-full py-4 px-6 bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-600 text-white font-bold text-lg rounded-lg transition duration-200 flex items-center justify-center gap-3 shadow-lg"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-6 w-6 border-3 border-white border-t-transparent"></div>
              در حال تنظیم...
            </>
          ) : (
            <>
              <span>🎭</span>
              تنظیم Fake System Start Time
            </>
          )}
        </button>
      </form>

      {/* 👇 نمایش اطلاعات بعد از update */}
      {updatedData && (
        <div className="space-y-4 mt-6 pt-6 border-t border-gray-700">
          <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
            <span>📊</span>
            اطلاعات به‌روز شده
          </h4>

          {/* Current Broker Time */}
          <div className="bg-blue-900/30 border-2 border-blue-600 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <span className="text-3xl">⏰</span>
              <div>
                <p className="text-blue-300 text-sm font-medium mb-1">
                  current_broker_time
                </p>
                <p className="text-white font-bold text-xl">
                  {updatedData.current_broker_time}
                </p>
              </div>
            </div>
          </div>

          {/* Fake System Start Time */}
          <div className="bg-indigo-900/30 border-2 border-indigo-600 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <span className="text-3xl">🎭</span>
              <div>
                <p className="text-indigo-300 text-sm font-medium mb-1">
                  fake_system_start_time
                </p>
                <p className="text-white font-bold text-xl">
                  {updatedData.fake_system_start_time}
                </p>
              </div>
            </div>
          </div>

          {/* Fake Time Description */}
          {updatedData.fake_time_description && (
            <div className="bg-gray-800/50 border border-gray-600 rounded-lg p-4">
              <div className="flex items-center gap-3">
                <span className="text-2xl">📝</span>
                <div>
                  <p className="text-gray-400 text-xs font-medium mb-1">
                    توضیحات
                  </p>
                  <p className="text-gray-300 text-sm">
                    {updatedData.fake_time_description}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SetFakeSystem;